import { render, staticRenderFns } from "./BoardWriteDefaultLayout.vue?vue&type=template&id=3488229c&scoped=true"
import script from "./BoardWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./BoardWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488229c",
  null
  
)

export default component.exports